<template>
  <div class="d-flex gap-2">
    <DxButton text="Importar IDs Cosmos" @click="onImportarCosmosClick" icon="upload" type="default" />
    <DxButton text="Importar nuevos estados" @click="onImportarNuevosEstadosClick" icon="upload" type="default" />
    <DxButton text="Importar bajas" @click="onImportarBajasClick" icon="upload" type="default" />
  </div>
</template>

<script setup lang="ts">
import { DxButton } from "devextreme-vue";
import { useApi } from "@api/integration";
import { useModalService } from "@services/modal-service";
import type { ImportResultDto } from "@api/api";
import { toastError } from "@/.shared/services/notification-service";

const emit = defineEmits<{
  'result:modified': [result: ImportResultDto];
}>();

const props = defineProps<{
  esSimulacion: boolean;
}>();

const api = useApi();
const modal = useModalService();

async function onImportarNuevosEstadosClick() {
  const file = await modal.uploadFileBox(
    { title: "Nuevos estados", required: true, allowedFileFormats: ["excel"] },
    "Nuevos estados"
  );

  if (file === undefined) return;

  const result = await api.callStandardApi("importEndesaNuevosEstadosOperacionEnergia", { showLoading: true }, props.esSimulacion, file);

  emit("result:modified", result);
}

async function onImportarBajasClick() {
  const file = await modal.uploadFileBox(
    { title: "Bajas", required: true, allowedFileFormats: ["excel"] },
    "Bajas"
  );

  if (file === undefined) return;

  const result = await api.callStandardApi("importEndesaBajasOperacionEnergia", { showLoading: true }, props.esSimulacion, file);

  emit("result:modified", result);
}

async function onImportarCosmosClick() {
  const file = await modal.uploadFileBox(
    { title: "IDs Cosmos", required: true, allowedFileFormats: ["excel"] },
    "IDs Cosmos"
  );

  if (file === undefined) return;

  const result = await api.callStandardApi("importEndesaCosmosOperacionEnergia", { showLoading: true }, props.esSimulacion, file);

  emit("result:modified", result);
}
</script>

<style scoped lang="scss"></style>
